var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#0C022F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 69.5C33.75 69.5 30.5 69.5 30.5 66.25C30.5 63 33.75 53.25 50 53.25C66.25 53.25 69.5 63 69.5 66.25C69.5 69.5 66.25 69.5 66.25 69.5H33.75ZM50 50C52.5859 50 55.0658 48.9728 56.8943 47.1443C58.7228 45.3158 59.75 42.8359 59.75 40.25C59.75 37.6641 58.7228 35.1842 56.8943 33.3557C55.0658 31.5272 52.5859 30.5 50 30.5C47.4141 30.5 44.9342 31.5272 43.1057 33.3557C41.2772 35.1842 40.25 37.6641 40.25 40.25C40.25 42.8359 41.2772 45.3158 43.1057 47.1443C44.9342 48.9728 47.4141 50 50 50V50Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.cf7a6d77cf197aa2afc84c619305754b.svg";
export { ForwardRef as ReactComponent };